
/* styles */
require("!!vue-style-loader!css-loader?minimize!../../node_modules/vue-loader/lib/style-rewriter?id=data-v-ac8b5ac6&scoped=true!../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ComponentTitle.vue")

var Component = require("!../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../node_modules/vue-loader/lib/selector?type=script&index=0!./ComponentTitle.vue"),
  /* template */
  require("!!../../node_modules/vue-loader/lib/template-compiler?id=data-v-ac8b5ac6!../../node_modules/vue-loader/lib/selector?type=template&index=0!./ComponentTitle.vue"),
  /* scopeId */
  "data-v-ac8b5ac6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ComponentTitle.vue
// module id = 18
// module chunks = 2